import React from 'react'
import styled from 'styled-components'
import { FormattedMessage } from 'react-intl'
import { Redirect } from 'react-router-dom'
import { getPatientFromMatch } from '@medeo/patients'
import { connect } from 'react-redux'
import WeeklyReportForm from '../../Documents/containers/WeeklyReportForm'
import AlertsTable from '../../Observations/containers/AlertsTable'
import HistoryTable from '../../Observations/containers/HistoryTable'
import ReviewsHistoryTable from '../../Documents/containers/ReviewsHistoryTable'
import WeeklyReportAlert from '../../Documents/containers/WeeklyReportAlert'
const Div = styled.div`
  display: grid;
  grid-template-columns: 1fr 3fr 1fr;
  grid-column-gap: 1rem;
  & > aside {
    display: flex;
    flex-direction: column;
  }

  & > main {
    table {
      width: 100%;
    }
  }
`

const PatientView = ({ patient }) => (
  <Div>
    {patient == null && <Redirect to={'/patients'} />}
    <aside>
      <span>Information patient</span>
      <FormattedMessage id="consentGiven" />
    </aside>
    <main>
      <FormattedMessage id="alerts">
        {label => <h2>{label}</h2>}
      </FormattedMessage>
      <AlertsTable patientId={patient.id} />
      <FormattedMessage id="weeklyReport">
        {label => <h2>{label}</h2>}
      </FormattedMessage>
      <WeeklyReportForm patient={patient} />
      <WeeklyReportAlert patient={patient.id} />
      <FormattedMessage id="history">
        {label => <h2>{label}</h2>}
      </FormattedMessage>
      <HistoryTable patientId={patient.id} />
      <FormattedMessage id="reviewHistory">
        {label => <h2>{label}</h2>}
      </FormattedMessage>
      <ReviewsHistoryTable patient={patient.id} />
    </main>
  </Div>
)

const mapStateToProps = (state, ownProps) => ({
  patient: getPatientFromMatch(state, ownProps.match)
})

export default connect(mapStateToProps)(PatientView)



// WEBPACK FOOTER //
// ./src/Patients/containers/PatientView.js